import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/labelTemplates'
import Component from 'components/LabelTemplates/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getLabelTemplateTypes: actions.getLabelTemplateTypes })(Component)
